import React, {useState} from 'react';
import {Menu, MenuItem, ListItemText, ListItemIcon, Stack} from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {SupportedLanguages} from 'interfaces';
import {useTranslation} from 'react-i18next';
import {useFlags} from 'launchdarkly-react-client-sdk';

import {ICON_SIZE} from 'appConstants';

interface AppTopBarLanguageMenuProps {
  onLanguageSelect?: (option: SupportedLanguages) => void;
}

export const AppTopBarLanguageMenu: React.FC<AppTopBarLanguageMenuProps> = ({onLanguageSelect}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const {t} = useTranslation('common');
  const {spanishTranslation} = useFlags();
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const getEnumKeyByValue = <T extends Record<string, string>>(enumObj: T, value: string): keyof T | undefined => {
    return (Object.keys(enumObj) as Array<keyof T>).find((key) => enumObj[key] === value);
  };

  const menuItems = Object.values(SupportedLanguages).map((option) =>
    !spanishTranslation && option === SupportedLanguages.spanish ? null : (
      <MenuItem
        key={option}
        data-testid={`language-menu-item-${option}`}
        onClick={() => {
          onLanguageSelect?.(option);
          handleClose();
        }}
      >
        <ListItemText primary={getEnumKeyByValue(SupportedLanguages, option)} />
      </MenuItem>
    ),
  );

  return (
    <>
      <Stack
        onClick={handleClick}
        data-testid={'change-language-menu'}
        direction={'row'}
        justifyContent={'space-between'}
        width={'100%'}
        justifyItems={'center'}
      >
        <ListItemIcon>
          <TranslateIcon fontSize={ICON_SIZE} />
        </ListItemIcon>
        <ListItemText>{t('changeLanguage')}</ListItemText>
        <ArrowRightIcon fontSize="small" color="secondary" />
      </Stack>
      <Menu
        id="languages-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        style={{zIndex: 3000}}
        sx={{margin: -2}}
      >
        {menuItems}
      </Menu>
    </>
  );
};
